import {
  Stack,
  Typography,
  Button,
} from '@mui/material';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const defaultProps = {
  attributeName: '',
  defaultValue: [],
  profile: {},
  terminologies: {},
  onChangeCallback: () => {},
};

export default function SelectAllSettings(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { attributeName, defaultValue, profile, terminologies, onChangeCallback } = mergedProps;
  const selectedData = profile[attributeName];
  const terminologiesData = terminologies[attributeName];

  const isSelectedAll = selectedData.length === terminologiesData.length;

  const handleSelectAll = () => {
    const allData = terminologiesData.map((t) => t.code);
    // eslint-disable-next-line no-param-reassign
    profile[attributeName] = allData;
    onChangeCallback(allData);
  };

  const handleSelectDefault = () => {
    // eslint-disable-next-line no-param-reassign
    profile[attributeName] = defaultValue;
    onChangeCallback(defaultValue);
  };

  return (
    <Stack direction='row' gap={3} alignItems='center'>
      <Typography>{selectedData.length} {attributeName} selected</Typography>
      {isSelectedAll ? (
        <Button variant='text' className='btn-text-primary' onClick={handleSelectDefault}>Reset To Default</Button>
      ) : (
        <Button variant='text' className='btn-text-primary' onClick={handleSelectAll}>
          Select All
        </Button>
      )}

    </Stack>
  );
}
